import { useEffect, useContext, type Context } from 'react';
import _ from 'underscore';
import * as validation from '@bingads-webui-react/validation';

import { useFloatingBannerApi } from './use-floating-banner-api';

export type ServerErrorSelector =
  | string
  | RegExp
  | readonly string[]
  | ((value: string) => boolean);

export interface FloatingBannerServerErrorProps {
  clientId?: ServerErrorSelector;
  code?: ServerErrorSelector;
  entity?: string;
  fieldSelector?: ServerErrorSelector;
}

export type ServerErrorMessages = readonly string[];

export const useFloatingBannerWithServerError = (serverErrorProps: FloatingBannerServerErrorProps): void => {
  const serverErrorApi = validation as typeof validation & {
    ServerErrorContext: Context<{
      removeErrors(props: FloatingBannerServerErrorProps): void;
    }>;
    useServerError(props: {
      serverErrorProps: FloatingBannerServerErrorProps;
      passiveMessages?: ServerErrorMessages;
    }): ServerErrorMessages;
  };
  const messages = serverErrorApi.useServerError({ serverErrorProps });
  const { removeErrors } = useContext(serverErrorApi.ServerErrorContext);
  const { showCustomizedWarning } = useFloatingBannerApi();

  useEffect(() => {
    if (!_.isEmpty(messages)) {
      showCustomizedWarning(_.first(messages) as string);
      removeErrors(serverErrorProps);
    }
  }, [messages, showCustomizedWarning, removeErrors, serverErrorProps]);
};
